module.exports = __webpack_public_path__ + "img/Eurasian_Coot.9134eb65.png";